export const TabIcons = ({ type, size = 24, color }) => {
  const icons = {
    recent: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 5.83333V10L12.5 12.5M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    allFiles: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M12.4974 2.5V5.83333C12.4974 6.05435 12.5852 6.26631 12.7415 6.42259C12.8978 6.57887 13.1097 6.66667 13.3307 6.66667H16.6641M12.4974 2.5H9.16406C8.72203 2.5 8.29811 2.67559 7.98555 2.98816C7.67299 3.30072 7.4974 3.72464 7.4974 4.16667V12.5C7.4974 12.942 7.67299 13.366 7.98555 13.6785C8.29811 13.9911 8.72203 14.1667 9.16406 14.1667H14.9974C15.4394 14.1667 15.8633 13.9911 16.1759 13.6785C16.4885 13.366 16.6641 12.942 16.6641 12.5V6.66667M12.4974 2.5L16.6641 6.66667M13.3307 14.1667V15.8333C13.3307 16.2754 13.1551 16.6993 12.8426 17.0118C12.53 17.3244 12.1061 17.5 11.6641 17.5H5.83073C5.3887 17.5 4.96478 17.3244 4.65222 17.0118C4.33966 16.6993 4.16406 16.2754 4.16406 15.8333V7.5C4.16406 7.05797 4.33966 6.63405 4.65222 6.32149C4.96478 6.00893 5.3887 5.83333 5.83073 5.83333H7.4974"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    shared: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.8333 15.833H4.16667C3.72464 15.833 3.30072 15.6574 2.98816 15.3449C2.67559 15.0323 2.5 14.6084 2.5 14.1663V4.99967C2.5 4.55765 2.67559 4.13372 2.98816 3.82116C3.30072 3.5086 3.72464 3.33301 4.16667 3.33301H7.5L10 5.83301H15.8333C16.2754 5.83301 16.6993 6.0086 17.0118 6.32116C17.3244 6.63372 17.5 7.05765 17.5 7.49967V10.833M13.3333 18.333L17.5 14.1663M17.5 14.1663V17.9163M17.5 14.1663H13.75"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    favourite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M12.1641 2.5V5.83333C12.1641 6.05435 12.2519 6.26631 12.4081 6.42259C12.5644 6.57887 12.7764 6.66667 12.9974 6.66667H16.3307M12.1641 2.5H6.33073C5.8887 2.5 5.46478 2.67559 5.15222 2.98816C4.83966 3.30072 4.66406 3.72464 4.66406 4.16667V15.8333C4.66406 16.2754 4.83966 16.6993 5.15222 17.0118C5.46478 17.3244 5.8887 17.5 6.33073 17.5H14.6641C15.1061 17.5 15.53 17.3244 15.8426 17.0118C16.1551 16.6993 16.3307 16.2754 16.3307 15.8333V6.66667M12.1641 2.5L16.3307 6.66667M10.3307 14.0142L8.52072 14.9625C8.46701 14.9905 8.40658 15.0029 8.34619 14.9985C8.2858 14.9941 8.22781 14.973 8.17872 14.9376C8.12962 14.9022 8.09134 14.8538 8.06815 14.7978C8.04496 14.7419 8.03777 14.6806 8.04739 14.6208L8.39322 12.6117L6.92906 11.1892C6.88535 11.1469 6.85441 11.0932 6.83976 11.0342C6.82511 10.9753 6.82734 10.9133 6.84619 10.8555C6.86505 10.7978 6.89977 10.7464 6.9464 10.7074C6.99303 10.6684 7.04968 10.6433 7.10989 10.635L9.13322 10.3417L10.0382 8.51417C10.0653 8.45974 10.107 8.41394 10.1587 8.38193C10.2104 8.34991 10.2699 8.33295 10.3307 8.33295C10.3915 8.33295 10.4511 8.34991 10.5028 8.38193C10.5544 8.41394 10.5962 8.45974 10.6232 8.51417L11.5282 10.3417L13.5516 10.635C13.6116 10.6436 13.668 10.6689 13.7144 10.7079C13.7609 10.747 13.7954 10.7982 13.8142 10.8559C13.8331 10.9135 13.8354 10.9753 13.8209 11.0342C13.8064 11.0931 13.7758 11.1468 13.7324 11.1892L12.2682 12.6117L12.6132 14.62C12.6236 14.6799 12.6169 14.7415 12.594 14.7978C12.5711 14.8541 12.5329 14.9028 12.4837 14.9385C12.4345 14.9742 12.3763 14.9953 12.3157 14.9996C12.255 15.0038 12.1944 14.991 12.1407 14.9625L10.3307 14.0142Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    trash: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M3.83594 5.83333H17.1693M8.83594 9.16667V14.1667M12.1693 9.16667V14.1667M4.66927 5.83333L5.5026 15.8333C5.5026 16.2754 5.6782 16.6993 5.99076 17.0118C6.30332 17.3244 6.72724 17.5 7.16927 17.5H13.8359C14.278 17.5 14.7019 17.3244 15.0144 17.0118C15.327 16.6993 15.5026 16.2754 15.5026 15.8333L16.3359 5.83333M8.0026 5.83333V3.33333C8.0026 3.11232 8.0904 2.90036 8.24668 2.74408C8.40296 2.5878 8.61492 2.5 8.83594 2.5H12.1693C12.3903 2.5 12.6022 2.5878 12.7585 2.74408C12.9148 2.90036 13.0026 3.11232 13.0026 3.33333V5.83333"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  };

  return icons[type];
};

export default TabIcons;
